import { MobizOrganizationRole } from '../../core';
import { WorkAppDriveUnit } from '../other/work-app-drive-unit.type';
import { WorkAppJournalLineDescriptionBehaviour } from '../other/work-app-journal-line-description-behaviour.enum';
import { ModuleSettings } from './module-settings.do';


/**
 * Module settings ValueSchema: WorkModuleSettings v2.
 */
export class WorkModuleSettings extends ModuleSettings {

  /**
   * Flag to enable/disable JobPhase tracking functionality.
   */
  public WorkJobPhases: boolean;

  /**
   * Flag to enable/disable JobTask tracking functionality.
   */
  public WorkJobTasks: boolean;

  /**
   * Flag to enable/disable Cost tracking functionality.
   */
  public TrackCost: boolean;

  /**
   * Flag to enable/disable the `More` details for work items.
   */
  public ShowMoreTextArea: boolean;

  /**
   * Flag to enable/disable Overtime tracking functionality.
   */
  public TrackOvertime: boolean;

  /**
   * Flag to enable/disable Driving tracking functionality.
   */
  public TrackDriving: boolean;

  /**
   * Flag to enable/disable user adding work to finished job.
   */
  public CanWorkOnFinishedJob: boolean;

  /**
   * Description text templates for assisting user when tracking work.
   * Multi line string where each line represents a template.
   */
  public WorkLineDescriptionTemplates: string;

  /**
   * Description text templates for assisting user when tracking cost.
   * Multi line string where each line represents a template.
   */
  public CostLineDescriptionTemplates: string;

  /**
   * Available drive units.  Used by client UI when displaying dropdown list for selecting drive units.
   */
  public DriveUnits: WorkAppDriveUnit[];

  /**
   * Which role can see billing option in UI.
   * If user is not in a matching role system uses default billing settings to decide if billing is enabled or not.
   */
  public WhoCanChangeBilling: MobizOrganizationRole;

  /**
   * Which role can manage jobs via UI.
   * Note: this definition is based on Role chaining.
   *    Owner => Owners only
   *    Administrator => Includes Owner
   *    User => Includes Administrator and Owner
   *    Guest => Includes all roles
   */
  public WhoCanManageJobs: MobizOrganizationRole;

  /**
   * Default drive unit.
   */
  public WorkAppDriveUnits: WorkAppDriveUnit;

  /**
   * Time input interval used by time input widget.
   */
  public TimeInputInterval: number;

  /**
   * Flag to enable/disable assigning automatically job numbers.
   */
  public AutomaticallyAssignJobNumbers: boolean;

  /**
   * Flag to enable/disable tracking cost warehouse.
   */
  public TrackCostWarehouse: boolean;

  /**
   * Flag to enable/disable using decimal representation of work hours
   * E.g., 1.5 instead of 1:30.
   */
  public UseDecimalRepresentationOfWorkHours: boolean;

  /**
   * Which roles can change the cost of a unit price in UI.
   */
  public WhoCanChangeCostUnitPrice: MobizOrganizationRole;

  /**
   * Controls where the Work/Cost entry default description is loaded form.
   */
  public DefaultJournalLineDescriptionBehaviour: WorkAppJournalLineDescriptionBehaviour;
}
